













































import { UiMenu, UiPopover, UiRippleInk } from '../keen-ui';

export default {
  name: 'navigation-menu-item',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    icon: String,
    route: Object,
    contrast: Boolean,
    children: Array,
    displayChildrenOnModal: Boolean,
    level: {
      type: Number,
      default: 0
    },
    isModal: Boolean,
    selected: Boolean,
    collapsed: Boolean,
    transition: Object // { durationInMillis: number; delayInMillis: number; }
  },
  components: {
    UiPopover,
    UiMenu,
    UiRippleInk
  },
  computed: {
    componentStyles: function () {
      if (!!this.transition) {
        const opacityTransitionDurationInMillis = (this.transition.durationInMillis / 2);
        const opacityTransitionDelayInMillis = (this.transition.delayInMillis + opacityTransitionDurationInMillis);
        return {
          transition: `height ${this.transition.durationInMillis}ms ${this.transition.delayInMillis}ms, opacity ${
            opacityTransitionDurationInMillis}ms ${opacityTransitionDelayInMillis}ms`
        };
      }
    }
  },
  watch: {
    collapsed: function (): void {
      if (!!this.$refs.childrenPopover) {
        this.$refs.childrenPopover.close();
      }
    }
  }
};

